module.exports = __webpack_public_path__ + "static/media/imdb.df2d9d79.svg";